
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.273 0H1.182C.532 0 0 .532 0 1.182v8.273h1.182V1.182h7.09V0zm1.773 2.364h-6.5c-.65 0-1.182.532-1.182 1.182v8.272c0 .65.532 1.182 1.182 1.182h6.5c.65 0 1.181-.532 1.181-1.182V3.546c0-.65-.532-1.182-1.181-1.182zm-6.5 9.454h6.5V3.546h-6.5v8.272z","fill":"#585858"}})])
          )
        }
      }
    